import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import I18n from 'I18n';
import AbstractRating from './AbstractRating';
export default function RatingInput(_ref) {
  let {
    rating,
    label
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["rating", "label"]);

  const [labelText, setLabelText] = useState(label);
  useEffect(() => {
    if (rating) {
      setLabelText(I18n.text(`marketplace-ui-reviews.ratingDescriptions.${rating}`));
    }
  }, [rating]);
  const onHoveredValueChange = useCallback(({
    target: {
      value
    }
  }) => {
    const currentValue = value || rating;

    if (currentValue) {
      setLabelText(I18n.text(`marketplace-ui-reviews.ratingDescriptions.${currentValue}`));
    } else {
      setLabelText(label);
    }
  }, [label, rating]);
  return /*#__PURE__*/_jsx(AbstractRating, Object.assign({
    className: "display-flex",
    disabled: false,
    rating: rating,
    label: labelText,
    onHoveredValueChange: onHoveredValueChange,
    height: '25px'
  }, rest));
}